/**
 * @desc：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=912514226
 * @mock https://mock.xiaojukeji.com/project/776/interface/api/cat_164416
 */
import didiaxios from '@didi/dajax/dist/dajax'
import apiConfig from '@/common/js/apiConfig'
// eslint-disable-next-line no-unused-vars
import { mock } from './mockglobal.js'

const BASE_URL = apiConfig.BASE_API_C

// 商家会员信息
const GET_SHOP_BIND_INFO = BASE_URL + '/grocery/shopLoyalty'
// 商家会员绑定/解绑
const BIND_SHOP_MEMBER = BASE_URL + '/grocery/shopLoyaltyBind'

export const apiGetShopMemberInfo = function (data) {
  return requestPOST(GET_SHOP_BIND_INFO, data)
}
export const apiBindShopMember = function (data) {
  return requestPOST(BIND_SHOP_MEMBER, data)
}

async function requestPOST(url, data) {
  const globalParams = (await SodaBridge('getGlobalParams', 'badcase')) || {}
  const paramsData = globalParams.data || {}

  return didiaxios
    .request({
      url,
      method: 'POST',
      emulateJSON: true,
      needEncrypt: true,
      params: '',
      body: {
        // ...mock,
        ...paramsData,
        ...data,
      },
    })
    .then(res => res.data)
    .catch(err => console.log(err))
}
